// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { localize } from 'i18n-calypso'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import PageHeader from 'church-theme-library/pages/PageHeader'
import LoadingSpinner from 'church-theme-library/components/LoadingSpinner/LoadingSpinner'
import PostSectionFeatureDouble from 'church-theme-library/components/PostSections/PostSectionFeatureDouble'
import PostSectionB from 'church-theme-library/components/PostSections/PostSectionB'

class SermonSeriesLayout extends React.Component {
	componentDidMount() {
		window.scrollTo( 0, 0 )
		// window.scrollTo( { top: 0, behavior: 'smooth' } )
	}

	renderContent() {
		const {
			type,
			selectedArchive,
			match,
			loadingById,
			showSetA,
			showSetZ,
			postsSetA,
			postsSetZ,

			translate
		} = this.props

		if ( ! showSetA && ! showSetZ ) {
			return null
		}

		return (
			<div className="wide-sections">
				{/* Single Sermons */}

				{ showSetZ && postsSetZ &&
					<PostSectionB
						type={ type }
						posts={ postsSetZ }
						showDateSelect={ false }
					/>
				}
			</div>
		)
	}

	render() {
		const { selectedArchive, isLoading, loadingById, match, translate } = this.props
		const slug = match.params.slug
		const catId = `id_${slug}`
		const hasCorrectArchiveData = ( selectedArchive && 'sermon-series' == selectedArchive.type )
		let showLoading = ! hasCorrectArchiveData || isLoading || ( loadingById && loadingById[ catId ] )

		return (
			<div>
				<PageHeader { ...this.props } />

				<div className="main-inner">
					{ showLoading &&
						<LoadingSpinner />
					||
						this.renderContent()
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		selectedArchive: state.page.selectedArchive,
		showSetA: state.page.showSetA,
		showSetZ: state.page.showSetZ,
		postsSetA: state.page.postsSetA,
		postsSetZ: state.page.postsSetZ,

		isLoading: state.page.isLoading,
		loadingById: state.page.loadingById
	}
}

export default localize(
	connect( mapStateToProps )( SermonSeriesLayout )
)
